import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

/**
 * Circular health score gauge.
 * value 0-100 → color dynamic.
 */
export default function HealthScore({ value, size = 160, label, testId = "health-score" }) {
  const { t } = useTranslation();
  const v = Math.max(0, Math.min(100, value || 0));
  const radius = size / 2 - 12;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (v / 100) * circ;

  const color = v >= 70 ? "#16A34A" : v >= 40 ? "#F59E0B" : "#DC2626";
  const colorLight = v >= 70 ? "#DCFCE7" : v >= 40 ? "#FEF3C7" : "#FEE2E2";
  const status = v >= 70 ? t("status.healthy") : v >= 40 ? t("status.monitor") : t("status.critical");
  const finalLabel = label || t("diag.delphi_health");

  return (
    <div className="flex flex-col items-center gap-2" data-testid={testId}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={radius} stroke={colorLight} strokeWidth={10} fill="none" />
          <motion.circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth={10}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circ}
            initial={{ strokeDashoffset: circ }}
            animate={{ strokeDashoffset: offset }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-heading font-black text-4xl md:text-5xl tracking-tighter" style={{ color }}>{v}</span>
          <span className="text-xs text-text-secondary font-medium">/ 100</span>
        </div>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-xs uppercase tracking-wider text-text-secondary">{finalLabel}</span>
        <span className="text-sm font-semibold" style={{ color }}>{status}</span>
      </div>
    </div>
  );
}
